import styled from 'styled-components'

export const VerticalItem = styled.li`
    max-width: 500px;
    list-style-type: none;
    padding-top: 12px;
    padding-bottom: 25px;
    a {
        color: ${(props) => props.theme.secondaryText};
        text-decoration: none;
    }
`

export const HorizontalItem = styled.li`
    max-width: 500px;
    list-style-type: none;
    padding: 6px 12px;
    a {
        color: ${(props) => props.theme.secondaryText};
        text-decoration: none;
    }
`

export const HorizontalList = styled.ul`
    width: 85vmin;
    max-width: 500px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding: 0;
    flex-wrap: wrap;
`

export const ShowMoreButton = styled.button`
    margin-top: 20px;
    margin-bottom: 24px;
    padding: 12px 22px;
    font-size: 15px;
    letter-spacing: 0.03em;
    background-color: rgba(255, 255, 255, 0.04);
    color: ${(props) => props.theme.text};
    border: 1px solid ${(props) => props.theme.border};
    border-radius: 999px;
    cursor: pointer;
    transition:
        background 0.2s ease,
        transform 0.2s ease,
        box-shadow 0.2s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        transform: translateY(-1px);
        box-shadow: 0 10px 20px rgba(5, 8, 15, 0.4);
    }
`

export const StoreCard = styled.a`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 14px;
    padding: 12px 14px;
    width: 100%;
    max-width: 380px;
    text-decoration: none;
    color: ${(props) => props.theme.text};
    box-shadow: 0 10px 24px rgba(3, 5, 9, 0.44);
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease,
        background 0.2s ease;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 16px 34px rgba(3, 5, 9, 0.6);
        background: rgba(255, 255, 255, 0.08);
    }
`

export const CallToAction = styled.div`
    padding: 8px 15px;
    background: rgba(255, 255, 255, 0.08);
    color: ${(props) => props.theme.text};
    border: 1px solid ${(props) => props.theme.border};
    font-weight: 600;
    border-radius: 20px;
    font-size: 13px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    transition:
        background 0.2s ease,
        color 0.2s ease;

    ${StoreCard}:hover & {
        background: rgba(255, 255, 255, 0.14);
        color: ${(props) => props.theme.text};
    }
`

export const AlbumCover = styled.img`
    width: 100%;
    max-width: 400px;
    padding: 0;
    margin: 0 auto;
    display: block;
    border-radius: 18px;
    border: 1px solid ${(props) => props.theme.border};
    box-shadow: 0 24px 44px rgba(2, 4, 10, 0.55);
`

export const Title = styled.h1`
    font-size: clamp(1.35rem, 2vw, 1.9rem);
    font-weight: 700;
    margin: 0 0 18px;
    color: ${(props) => props.theme.text};
    letter-spacing: 0.01em;
    text-wrap: balance;
`

export const StoreList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    padding: 20px 8px 0 8px;
    box-sizing: border-box;
    width: 100%;
`

export const StoreLogo = styled.img`
    height: 42px;
    width: auto; /* Maintain aspect ratio */
    margin-right: 12px; /* Space between logo and button */
`

export const OfferText = styled.div`
    font-weight: bold;
    font-size: 22px;
    flex-shrink: 0;
    margin-right: 10px; /* Keeps same spacing as StoreLogo would have */
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.text}; /* Use the theme text color */
    padding: 4px 10px;
    border-radius: 6px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-family: 'Inter', sans-serif;
    box-shadow: none;
    backdrop-filter: blur(5px); /* Adds a slight glass effect */
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6px 16px 0;
    color: ${(props) => props.theme.text};
    width: 100%;
    max-width: 1120px;
    box-sizing: border-box;
    overflow-x: hidden;
    margin: 0 auto;
    background-color: transparent;
`
